<ng-container [formGroup]="baseFormGroup">
  <!-- row -->
  <div class="row">
    <button (click)="removeDetail()" class="btn btn-remove btn-sm btn-danger" [class.d-none]="formGroupName === 0" type="button" [disabled]="!isEditable">
      Remove
    </button>
    <div class="col-12"><p style="font-weight:700; font-size:1.4rem">{{ label }} {{ textNumber[formGroupName] }}</p></div>
    <ng-container *ngFor="let question of childQuestions">
      <ng-container *ngIf="isNotMultipleResponseChild(question) && question.ParentQuestionName !== 'IULProceedsAllocToCompound'">
        <div class="col-12" >
          <app-question
            [question]="question"
            [form]="baseFormGroup"
            [multiIndex]="formGroupName + 1"
            [childQuestions]="getChildQuestions(question)"
            [isEditable]="isEditable"
            *ngIf="isQuestionVisible(question)">
          </app-question>
        </div>
      </ng-container>
    </ng-container>
  </div>
  <!-- /row -->
</ng-container>
